// src\themes\default\components\GalleryWidget.tsx
import TextWidget from './TextWidget';
import ImageWidget from './ImageWidget';

type GalleryItem = {
    type: 'text' | 'image';
    width?: string;
    direction?: 'left' | 'center' | 'right';
    title?: string;
    title_en?: string;
    title_ar?: string;
    description?: string;
    description_en?: string;
    description_ar?: string;
    image?: {
        url: string;
        name?: string;
        description?: string;
    };
    orientation?: 'horizontal' | 'vertical';
};

type GalleryWidgetData = {
    items?: GalleryItem[];
};

export default function GalleryWidget({ data }: { data: GalleryWidgetData }) {
    const items = data?.items || [];

    return (
        <div className="grid grid-cols-12 col-span-12 gap-4 w-full">
            {items.map((item, index) => {
                const widthMap: Record<string, string> = {
                    '1/1': 'col-span-12',
                    '1/2': 'col-span-12 md:col-span-6',
                    '1/3': 'col-span-12 md:col-span-4',
                    '1/4': 'col-span-12 md:col-span-3',
                    '2/3': 'col-span-12 md:col-span-8',
                    '3/4': 'col-span-12 md:col-span-9',
                };

                const itemWidth = widthMap[item.width || '1/1'];

                if (item.type === 'text') {
                    return (
                        <div key={index} className={itemWidth}>
                            <TextWidget
                                data={{
                                    direction: item.direction || 'left',
                                    width: item.width || '1/1',
                                    items: [
                                        {
                                            title: item.title,
                                            description: item.description,
                                            width: item.width || '1/1',
                                        },
                                    ],
                                }}
                            />
                        </div>
                    );
                }

                if (item.type === 'image') {
                    return (
                        <div key={index} className={itemWidth}>
                            <ImageWidget
                                data={{
                                    width: item.width || '1/1',
                                    direction: item.direction || 'left',
                                    orientation: item.orientation || 'horizontal',
                                    title: item.title,
                                    description: item.description,
                                    image: item.image,
                                }}
                            />
                        </div>
                    );
                }

                return null;
            })}
        </div>
    );
}